import {fromJS} from 'immutable';

import dieselReducer from '../../decorators/DieselReducer';

const DEFAULT_STATE = 'US';

export function bootstrap(data) {
    return fromJS({ipCountryCode: data.ipCountryCode});
}

function ipCountryCode(state = DEFAULT_STATE) {
    return state;
}
export default ipCountryCode;

dieselReducer('ipCountryCode', ipCountryCode, bootstrap);
